var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("custom-page", {
    attrs: {
      title: "作业信息：",
      "import-template": true
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };